export var apiWhiteList = ['/uaa/oauth/token'];